
import { defineComponent, PropType } from "vue";
import { Insight } from "@/models/insight";
import SingleSelect from './SingleSelect.vue'
import TextInput from './TextInput.vue'
import IBMultiSelect from "./IBMultiSelect.vue";
import DropDownSelect from './DropdownSelect.vue'
import CalculatedPercent from './CalculatedPercent.vue'

export default defineComponent({
  name: "ObservationController",
  computed: {
    getComponentType() {
      if (this.insight) {
        if (this.insight.controller?.type) {
          switch (this.insight.controller.type) {
            case 'observation_single':
              return SingleSelect
            case 'multi':
              return IBMultiSelect
            case 'select':
              return DropDownSelect
            case 'calculate_percent':
              return CalculatedPercent
            default:
              return TextInput
          }
        } else {
          return TextInput
        }
      } else {
        return null
      }
    }
  },
  props: {
    insight: {
      type: Object as PropType<Insight>,
    },
    prefill: {
      type: [String, Number, Array],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
  },
})
